import { getSearchResults, handleOnClick, label } from './SearchField.helper';
import reactStringReplace from 'react-string-replace';
import { Styled } from '.';
import { useRouter } from 'next/router';
import { useProductNameList } from '../../reactQuery/queries/useProductNameList';
import { LoadingSpinner } from '../../styles/sharedStyles';
import { useI18n } from '../../contexts/i18n';

interface SuggestionListProps {
  searchText: string;
  hideSearchResultsModal(): void;
}

function SuggestionList({
  searchText,
  hideSearchResultsModal,
}: SuggestionListProps) {
  const router = useRouter();
  const { data, isLoading, isError, error } = useProductNameList();
  const i18n = useI18n();

  // Get the matching search results, IF undefined, returns empty array
  const filteredResults = getSearchResults(searchText, data) ?? [];

  // Check if there are filtered results
  const isMatchingSearchResult = filteredResults?.length > 0;

  // when status isLoading, display loading indicator
  if (isLoading) return <LoadingSpinner />;
  // when status isError, logs error with error message
  if (isError) {
    console.error(error);
    return <>{label(i18n).errorOccured}</>;
  }
  return (
    (<Styled.SuggestionList data-testid="search-results">
      {isMatchingSearchResult ? (
        filteredResults?.map(filteredResult => {
          return (
            <Styled.SuggestionListItem
              key={filteredResult.sku}
              // navigates user to the given location when clicking on the element + closes search modal
              onClick={() =>
                handleOnClick(
                  filteredResult.slug,
                  hideSearchResultsModal,
                  router
                )
              }
            >
              {/*
                Replace normal text with bold text where the filtered search result
                matches the input value
              */}

              <Styled.ItemName>
                {reactStringReplace(
                  filteredResult.name,
                  searchText,
                  (match: string, index) => (
                    <strong key={index}>{match}</strong>
                  )
                )}
              </Styled.ItemName>
              <Styled.ItemSKU>
                {i18n['SKU'] ?? 'SKU'}:{' '}
                {reactStringReplace(
                  filteredResult.sku,
                  searchText,
                  (match: string, index) => (
                    <strong key={index}>{match}</strong>
                  )
                )}
              </Styled.ItemSKU>
            </Styled.SuggestionListItem>
          );
        })
      ) : (
        //  in case of no search results, specific label displayed
        (<Styled.Label>{label(i18n).noresults}</Styled.Label>)
      )}
    </Styled.SuggestionList>)
  );
}

export default SuggestionList;
